import React, { FC } from 'react';
import { Box, Text, Button, Image } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './SideContent.scss';
import shared from '../../../../styles/shared.scss';
import { useVisibleCategories } from '../../hooks/useVisibleCateogries';
import { useSaveCategoryValue } from '../../hooks/useSaveCategoryValue';
import { CATEGORY_PREVIEWS } from '../../consts/categoryPreviews';
import { Dot } from '../../../../components/Dot';
import { ChevronRight } from 'wix-ui-icons-common';
import { CardLayout } from '../../../../components/layouts';

export interface SideContentProps {}

export const SideContent: FC<SideContentProps> = () => {
  const { t } = useTranslation();
  const { saveCategoryValue, isLoading, categoryValue } = useSaveCategoryValue();
  const previewImages = CATEGORY_PREVIEWS?.[categoryValue]?.images || [];

  const visibleCategories = useVisibleCategories({});

  const selectedCategoryData = categoryValue
    ? visibleCategories.find(([key]) => key === categoryValue)?.[1]
    : null;

  return (
    <CardLayout>
      <Box direction="vertical" gap={4}>
        <Box direction="vertical" gap={2}>
          <Text weight="bold">{t('categories.side_content.header')}</Text>

          <Text weight="thin">
            {selectedCategoryData
              ? t('categories.side_content.subtitle_content', { category: t(selectedCategoryData.name) })
              : t('categories.side_content.subtitle')}
          </Text>
        </Box>

        {previewImages?.length > 0 && (
          <Box direction="vertical" gap={2}>
            <Box verticalAlign="middle" gap={2}>
              <Dot />
              <Text weight="bold">{t('categories.side_content.secondary_subtitle')}</Text>
            </Box>

            <Box className={s.previewContainer} width="100%" gap={2}>
              {previewImages.map((image, index) => (
                <Box key={index} className="preview-image">
                  <Image src={image} fit="cover" />
                </Box>
              ))}
            </Box>
          </Box>
        )}

        <Button
          className={shared.buildButton}
          disabled={!categoryValue || isLoading}
          size="large"
          fullWidth
          onClick={saveCategoryValue}
          suffixIcon={<ChevronRight />}
        >
          Build your store
        </Button>
      </Box>
    </CardLayout>
  );
};
